
<div *ngIf="IsInit">
    <router-outlet></router-outlet>
    <p-toast></p-toast>
    
</div>

<ngx-loading
    class="loading"
    [show]="!IsInit"
    [config]="{
      animationType: ngxLoadingAnimationTypes.wanderingCubes,
      primaryColour: primaryColour,
      secondaryColour: secondaryColour,
      backdropBorderRadius: '0px'
    }">
</ngx-loading>